import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  raised?: boolean;
  children?: ReactNode;
}

export function Card({ raised = false, className, children, ...rest }: CardProps) {
  return (
    <div className={clsx(styles.card, raised && styles.raised, className)} {...rest}>
      {children}
    </div>
  );
}

export interface CardHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function CardHeader({ title, subtitle, actions, className }: CardHeaderProps) {
  return (
    <div className={clsx(styles.header, className)}>
      <div className={styles.headerText}>
        <div className={styles.title}>{title}</div>
        {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}

export interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
  flush?: boolean;
}

export function CardBody({ flush = false, className, children, ...rest }: CardBodyProps) {
  return (
    <div className={clsx(styles.body, flush && styles.bodyFlush, className)} {...rest}>
      {children}
    </div>
  );
}
